import { BASE_URL } from '../BASE_URL';

export const getNews = async () => {
  const response = await fetch(BASE_URL + 'news/', {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};
